import connectRelatedProducts from "instantsearch.js/es/connectors/related-products/connectRelatedProducts.js";
import { useConnector } from "../hooks/useConnector.js";
export function useRelatedProducts(props, additionalWidgetProperties) {
  return useConnector(connectRelatedProducts, props, additionalWidgetProperties);
}